export default __webpack_public_path__ + "static/media/ordi2.8eebbff4.jpg";